/**
 * Global Beans floating cart — opens on PDP Add to cart and via CART button.
 */
(function () {
  const root = document.querySelector('[data-beans-floating-cart]');
  if (!root) return;

  window.Shopify = window.Shopify || {};
  if (!Shopify.formatMoney) {
    Shopify.formatMoney = (cents) => '$' + (Number(cents) / 100).toFixed(2);
  }

  const getActiveCart = () => {
    const desktop = root.querySelector('[data-beans-cart="desktop"]');
    const mobile = root.querySelector('[data-beans-cart="mobile"]');
    const isDesktop = window.matchMedia('(min-width: 769px)').matches;
    const el = isDesktop ? desktop : mobile;
    if (!el || getComputedStyle(el).display === 'none') {
      return isDesktop ? mobile : desktop;
    }
    return el;
  };

  const formatMoney = (cents) => Shopify.formatMoney(cents);

  const renderCartInto = (cartEl, cart) => {
    if (!cartEl) return;

    cartEl.querySelectorAll('[data-beans-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
    });

    const itemsWrap = cartEl.querySelector('[data-beans-cart-items]');
    const subtotalEl = cartEl.querySelector('[data-beans-cart-subtotal]');
    const checkoutBtn = cartEl.querySelector('[data-beans-cart-checkout]');
    const isMobile = cartEl.dataset.beansCart === 'mobile';
    const itemClass = isMobile ? 'm-cart-item' : 'd-cart-item';
    const infoClass = isMobile ? 'm-cart-item-info' : 'd-cart-item-info';
    const titleClass = isMobile ? 'm-cart-item-title' : 'd-cart-item-title';
    const variantClass = isMobile ? 'm-cart-item-variant' : 'd-cart-item-variant';
    const priceClass = isMobile ? 'm-cart-item-price' : 'd-cart-item-price';
    const removeClass = isMobile ? 'm-cart-remove-btn' : 'd-cart-remove';

    if (itemsWrap) {
      if (!cart.items || cart.items.length === 0) {
        itemsWrap.innerHTML =
          '<p class="text-center" style="font-size:12px; opacity:0.6">Cart is empty</p>';
      } else {
        itemsWrap.innerHTML = cart.items
          .map(
            (item) => `
          <div class="${itemClass}">
            <img src="${item.image || ''}" alt="${item.title || ''}">
            <div class="${infoClass}">
              <div class="${titleClass}">${item.product_title}</div>
              ${
                item.variant_title
                  ? `<div class="${variantClass}" style="font-size:11px; opacity:0.6; margin-bottom:2px;">${item.variant_title}</div>`
                  : ''
              }
              <div class="${priceClass}">${formatMoney(item.price)} x ${item.quantity}</div>
              <button type="button" class="${removeClass}" data-beans-remove-key="${item.key}" style="background:none;border:none;color:#fff;text-decoration:none;cursor:pointer;font-size:10px;padding:0;margin-top:5px;">***remove***</button>
            </div>
          </div>`
          )
          .join('');

        itemsWrap.querySelectorAll('[data-beans-remove-key]').forEach((btn) => {
          btn.addEventListener('click', () => removeItem(btn.getAttribute('data-beans-remove-key')));
        });
      }
    }

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (checkoutBtn) checkoutBtn.style.display = cart.item_count === 0 ? 'none' : 'block';
  };

  const onHomepageSlider =
    document.querySelector('.collection-bg-v3') || document.querySelector('.m-collection-slider');

  const refresh = () =>
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        root.querySelectorAll('[data-beans-cart]').forEach((cartEl) => renderCartInto(cartEl, cart));
        document.querySelectorAll('.cart-count').forEach((el) => {
          el.textContent = cart.item_count;
        });
        return cart;
      })
      .catch((err) => console.error('Beans floating cart refresh failed', err));

  const open = () => {
    const cartEl = getActiveCart();
    if (!cartEl || getComputedStyle(cartEl).display === 'none') return Promise.resolve();

    return refresh().then(() => {
      const overlay = cartEl.querySelector('[data-beans-cart-overlay]');
      if (overlay) {
        overlay.classList.add('active');
        overlay.style.opacity = '1';
        overlay.style.pointerEvents = 'auto';
      }
      document.documentElement.classList.add('beans-cart-open');
    });
  };

  const close = () => {
    root.querySelectorAll('[data-beans-cart-overlay]').forEach((overlay) => {
      overlay.classList.remove('active');
      overlay.style.opacity = '';
      overlay.style.pointerEvents = '';
    });
    document.documentElement.classList.remove('beans-cart-open');
  };

  const isAvailable = () => {
    const desktop = root.querySelector('[data-beans-cart="desktop"]');
    const mobile = root.querySelector('[data-beans-cart="mobile"]');
    return [desktop, mobile].some((el) => el && getComputedStyle(el).display !== 'none');
  };

  window.BeansFloatingCart = { open, close, refresh, isAvailable };

  refresh();

  if (onHomepageSlider) return;

  // PDP / other pages only — homepage sliders use their own cart panels

  const removeItem = (key) => {
    if (!key) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    })
      .then((r) => r.json())
      .then(() => refresh())
      .catch((err) => console.error('Beans floating cart remove failed', err));
  };

  // Bind triggers / close / outside click
  root.querySelectorAll('[data-beans-cart]').forEach((cartEl) => {
    const trigger = cartEl.querySelector('[data-beans-cart-trigger]');
    const closeBtn = cartEl.querySelector('[data-beans-cart-close]');
    const backdrop = cartEl.querySelector('[data-beans-cart-backdrop]');
    const panel = cartEl.querySelector('[data-beans-cart-panel]');
    const overlay = cartEl.querySelector('[data-beans-cart-overlay]');

    trigger?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      open();
    });

    closeBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      close();
    });

    backdrop?.addEventListener('click', close);

    document.addEventListener('click', (e) => {
      if (!overlay?.classList.contains('active')) return;
      if (panel?.contains(e.target) || trigger?.contains(e.target)) return;
      close();
    });
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      refresh();
    });
  }
})();
